const PayjpCheckout = {
  name: 'PayjpCheckout',
  render(createElement) {
    return createElement('div', {});
  },
  props: {
    apiKey: {
      type: String,
      required: true,
      default: null,
    },
    clientId: String,
    partial: {
      type: Boolean,
      default: false,
    },
    text: String,
    submitText: String,
    tokenName: String,
    previousToken: String,
    lang: {
      type: String,
      default: 'ja'
    },
    namePlaceholder: String,
    tenant: {
      type: String,
      default: null,
    },
    defaultEmail: {
      type: String,
      default: null,
    },
    enablePhoneNumber: {
      type: Boolean,
      default: false,
    },
    random: Function,
    onCreatedHandler: Function,
    onFailedHandler: Function,
  },
  data() {
    return {
      randomu: null,
    };
  },
  emits: ['created', 'failed'],
  mounted() {

    // モーダルからwindow経由でメソッドを呼び出すとpropsにアクセスできないため
    // propsの内容を変数に格納
    const onCreated = this.onCreatedHandler;
    const onFailed  = this.onFailedHandler;

    /**
     * モーダルにて正常
     * @param response
     */
    function onCreateToken(response) {
      onCreated(response);
    }

    function onCreateTokenFailed(statusCode, errorResponse) {
      onFailed(statusCode, errorResponse);
    }

    window.payjpCheckoutOnCreated = onCreateToken
    window.payjpCheckoutOnFailed = onCreateTokenFailed

    const scriptEl = document.createElement('script');
    // https://pay.jp/docs/checkout

    scriptEl.dataset['onCreated'] = "payjpCheckoutOnCreated"
    scriptEl.dataset['onFailed'] = this.onFailedHandler ? "payjpCheckoutOnFailed" : null
    scriptEl.dataset['key'] = this.apiKey

    let attrs = {
      src: 'https://checkout.pay.jp/',
      class: 'payjp-button',
      'data-key': this.apiKey,
      'data-payjp': this.clientId,
      'data-partial': !!this.partial,
      'data-text': this.text,
      'data-submit-text': this.submitText,
      'data-token-name': this.tokenName,
      'data-previous-token': this.previousToken,
      'data-lang': this.lang,
      'data-name-placeholder': this.namePlaceholder,
      'data-tenant': this.tenant,
    };
    if (this.defaultEmail) {
      attrs['data-payjp-extra-attribute-email'] = this.defaultEmail;
    }
    if (this.enablePhoneNumber) {
      attrs['data-payjp-extra-attribute-phone'] = this.enablePhoneNumber;
    }
    Object.keys(attrs).forEach(key => {
      const value = attrs[key];
      scriptEl.setAttribute(key, value);
    });
    this.$el.appendChild(scriptEl);
  },
  beforeDestroy() {
    console.log("beforeDestroy in.", window.PayjpCheckout)
    if (document.getElementById("payjp-checkout-iframe").parentNode) {
      document.getElementById("payjp-checkout-iframe").parentNode.remove();
    }
    window.payjpCheckoutOnCreated = null;
    window.payjpCheckoutOnFailed = null;
    window.PayjpCheckout = null;
  },
  methods: {}
};

// window.PayjpCheckout = PayjpCheckout;

export default PayjpCheckout;